import { trpc } from '@/lib/api/trpc';
import { useSessionClaims } from './use-session-claims';

/**
 * Hook to check if the current user has account-manager privileges.
 *
 * Role info (tgdRoles, whitelabelScope) now comes from the session token —
 * no network hop. We still fetch `getCurrentUserInfo` lazily only for fields
 * that are NOT in the session claims (orgRole, isLimited, accountRestrictions).
 * Consumers that only need role info should use `useSessionClaims()` directly.
 */
export function useAccountManager() {
    const { isAccountManager, tgdRoles, isLoaded: claimsLoaded } = useSessionClaims();

    const { data: userInfo, isLoading: trpcLoading } = trpc.users.getCurrentUserInfo.useQuery(
        {},
        {
            staleTime: 5 * 60 * 1000,
            gcTime: 10 * 60 * 1000,
            refetchOnWindowFocus: false,
            retry: 1,
        }
    );

    return {
        isAccountManager,
        isLimited: userInfo?.isLimited ?? false,
        tgdRoles,
        orgRole: userInfo?.orgRole ?? null,
        isLoading: !claimsLoaded || trpcLoading,
        userInfo,
    };
}
